import React from 'react';

export default function UserIcon({
  color = '#2D264B',
  w = '16',
  h = '21',
}: {
  color?: string;
  w?: string;
  h?: string;
}) {
  return (
    <svg
      width={w}
      height={h}
      viewBox='0 0 16 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.75 0C5.12665 0 3 2.12665 3 4.75C3 7.37335 5.12665 9.5 7.75 9.5C10.3734 9.5 12.5 7.37335 12.5 4.75C12.5 2.12665 10.3734 0 7.75 0ZM4.5 4.75C4.5 2.95507 5.95507 1.5 7.75 1.5C9.54493 1.5 11 2.95507 11 4.75C11 6.54493 9.54493 8 7.75 8C5.95507 8 4.5 6.54493 4.5 4.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.75 11C2.12665 11 0 13.1266 0 15.75C0 18.3734 2.12665 20.5 4.75 20.5H10.75C13.3734 20.5 15.5 18.3734 15.5 15.75C15.5 13.1266 13.3734 11 10.75 11H4.75ZM1.5 15.75C1.5 13.9551 2.95507 12.5 4.75 12.5H10.75C12.5449 12.5 14 13.9551 14 15.75C14 17.5449 12.5449 19 10.75 19H4.75C2.95507 19 1.5 17.5449 1.5 15.75Z'
        fill={color}
      />
    </svg>
  );
}
